import React from 'react'

import DefaultOrganizationLogo from 'src/components/DefaultOrganizationLogo'

import isDefaultLogo from 'src/utils/isDefaultLogo'
import cloudinaryUrl from 'src/utils/cloudinaryUrl'

const OrganizationLogo = ({ organization, width = 90, height = 90 }) =>
  isDefaultLogo(organization.logo_img)
  ? <DefaultOrganizationLogo size={height} />
  : <div className="organization-logo-bg bg-contain" style={{
      width: `${width}px`,
      height: `${height}px`,
      backgroundImage: `url('${cloudinaryUrl(organization.logo_img, {
        width: width * 2,
        height: height * 2,
        crop: 'limit',
      })}')`,
    }}></div>

export default OrganizationLogo
